import './liveTrackDriverInfo.css';
import driverImg from "../../assets/images/user-2.png";

const LiveTrackDriverInfo = ({data}) => {
    return(
        <div className={'accordion-sec'}>
            <div className="accordion-head padding-tb-20 sf-medium">
                <div className="head-content flex hr-space-between">
                    <ul className="separator gap-50">
                        {
                            data.map((item, index) =>
                                <li key={index} className={item?.class}>{item?.text}</li>
                            )
                        }
                    </ul>
                    <div className="flex padding-r-30">
                        <div className="user-img icon">
                            <img src={driverImg} alt=""/>
                        </div>
                        <div className="sf-bold">Ramesh Jagannath</div>
                    </div>
                </div>
                <div className="plus-minus-icon"></div>
            </div>
        </div>
    )
}

export default LiveTrackDriverInfo;
